import React from 'react'
import {
  CheckboxGroupInput,
  CreateBase,
  Datagrid,
  EditBase,
  // FormDataConsumer,
  FunctionField,
  type Identifier,
  type InputProps,
  // List,
  ListBase,
  ListToolbar,
  Loading,
  Pagination,
  type RaRecord,
  required,
  type RowClickFunction,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useDataProvider,
  useGetList,
  useListContext,
  useRefresh,
  useTranslate
} from 'react-admin'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DownloadIcon from '@mui/icons-material/Download'
import UploadIcon from '@mui/icons-material/Upload'
import { useFormContext } from 'react-hook-form'
import {
  compact,
  filter,
  find,
  groupBy,
  includes,
  isEmpty,
  isNil,
  join,
  keys,
  map,
  reduce,
  uniq
} from 'lodash/fp'
import log from 'loglevel'
import { type ConfigProps } from 'components/Dashboard'
import { SolarAccountsUploadDialog } from 'components/Upload'
import { SolarAccountsDownloadDialog } from 'components/Download'
import { type Partner } from '@mzc-watchover/adminapp-appsync'

log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

export const Accounts: React.FC<
  ConfigProps & { partner: Partial<Partner> }
> = ({ config, partner }) => {
  const { Accounts: configAccounts, Mappings: configMappings } = config
  const translate = useTranslate()
  const [mutate, setMutate] = React.useState(false)
  const [mode, setMode] = React.useState<string | undefined>(undefined)
  const [record, setRecord] = React.useState<string | undefined>(undefined)
  const [upload, setUpload] = React.useState(false)
  const [download, setDownload] = React.useState(false)
  const refresh = useRefresh()
  const handleCreate = (): void => {
    setMode('create')
    setMutate(true)
  }
  const handleUpload = (): void => {
    setUpload(true)
  }
  const handleDownload = (): void => {
    setDownload(true)
  }
  const AccountsListActions: React.FC = () => {
    return (
      <TopToolbar>
        <Button onClick={handleDownload} startIcon={<DownloadIcon />}>
          <Typography variant="h6">
            {translate('resources.accounts.buttons.download')}
          </Typography>
        </Button>
        <Button onClick={handleUpload} startIcon={<UploadIcon />}>
          <Typography variant="h6">
            {translate('resources.accounts.buttons.upload')}
          </Typography>
        </Button>
        <Button onClick={handleCreate} startIcon={<AddIcon />}>
          <Typography variant="h6">
            {translate('resources.accounts.buttons.create')}
          </Typography>
        </Button>
      </TopToolbar>
    )
  }
  const AccountsMutateFormContent: React.FC = () => {
    const { total, isLoading } = useGetList('mappings', {
      pagination: { perPage: 1, page: 1 },
      sort: { field: 'id', order: 'ASC' }
    })
    const dataProvider = useDataProvider()
    const [allArea, setAllArea] = React.useState<string[]>([])
    const [allOffice, setAllOffice] = React.useState<any>([])
    const { setValue, getValues } = useFormContext()
    const [selectArea, setArea] = React.useState<string | undefined>(
      getValues()['area']
    )
    const [disabled, setDisabled] = React.useState(false)
    // const [selectManager, setSelectManager] = React.useState(false)
    // const handleClose = (): void => {
    //   setSelectManager(false)
    // }
    // // const dialog = React.useMemo(() => {
    // //   const handleRowClick: RowClickFunction = (
    // //     _id: Identifier,
    // //     _resource: string,
    // //     record: RaRecord
    // //   ): any => {
    // //     setValue('managedBy', record['email'])
    // //     setSelectManager(false)
    // //     return false
    // //   }
    // //   return (
    // //     <Dialog
    // //       onClose={handleClose}
    // //       open={selectManager}
    // //       maxWidth="md"
    // //       fullWidth>
    // //       <DialogTitle>
    // //         {translate('resources.accounts.dialogs.selectManager.title')}
    // //       </DialogTitle>
    // //       <DialogContent>
    // //         <List resource="accounts">
    // //           <Datagrid bulkActionButtons={false} rowClick={handleRowClick}>
    // //             <TextField source="name" />
    // //             <TextField source="email" />
    // //           </Datagrid>
    // //         </List>
    // //       </DialogContent>
    // //     </Dialog>
    // //   )
    // // }, [])
    const { group } = configAccounts
    const values = getValues()
    const GroupInput: React.FC<InputProps> = () => {
      React.useEffect(() => {
        const { group } = values
        if (includes('admin')(group)) {
          setValue('group2', ['admin'], {
            shouldDirty: true
          })
        }
        const group1 = filter((item: string) => item !== 'admin')(group)
        setValue('group1', isEmpty(group1) ? undefined : group1[0], {
          shouldDirty: true
        })
      }, [values])
      return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
          <SelectInput
            source="group1"
            label="resources.accounts.fields.group"
            choices={[
              {
                id: 'highManager',
                name: group.highManager
              },
              {
                id: 'manager',
                name: group.manager
              },
              { id: 'owner', name: group.owner }
            ]}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement> | RaRecord<Identifier>
            ): void => {
              const { group2 } = getValues()
              const group1 = isEmpty(event.target.value)
                ? null
                : event.target.value
              setValue(
                'group',
                compact(isNil(group2) ? [group1] : [group1, ...group2]),
                {
                  shouldDirty: true
                }
              )
            }}
          />
          <CheckboxGroupInput
            source="group2"
            label={false}
            choices={[{ id: 'admin', name: group.admin }]}
            onChange={(...event: any[]): void => {
              const { group1 } = getValues()
              const group2 = isEmpty(event[0]) ? [] : event[0]
              setValue(
                'group',
                compact(
                  isNil(group1) || isEmpty(group1)
                    ? group2
                    : [group1, ...group2]
                ),
                {
                  shouldDirty: true
                }
              )
            }}
          />
        </Box>
      )
    }
    React.useEffect(() => {
      if (isLoading || isNil(total) || total === 0) return
      if (!isEmpty(allArea) && !isEmpty(allOffice)) return
      const { area, office } = configMappings
      dataProvider
        .getList('mappings', {
          pagination: { perPage: total, page: 1 },
          sort: { field: 'id', order: 'ASC' },
          filter: {}
        })
        .then(({ data }) => {
          const items = reduce(
            (
              sum: {
                [area]: string[]
                [office]: Array<{ [area]: string; [office]: string }>
              },
              item: { [area]: string; [office]: string }
            ) => {
              const areaSum = sum[area] as string[]
              areaSum.push(item[area] as string)
              const officeSum = sum[office] as Array<{
                [area]: string
                [office]: string
              }>
              officeSum.push(item)
              return { [area]: uniq(areaSum), [office]: uniq(officeSum) }
            },
            { [area]: [], [office]: [] }
          )(data)
          setAllArea(items[area] as string[])
          const offices = groupBy<{ [area]: string; [office]: string }>(area)(
            items[office] as string[]
          )
          setAllOffice(
            reduce(
              (sum: Record<string, any>, key: string) => ({
                ...sum,
                [key]: uniq(map((item: any) => item[office])(offices[key]))
              }),
              {}
            )(keys(offices))
          )
          const { name, group } = values
          if (!isNil(name) && includes('manager')(group)) {
            const managed = find((item: any) => item.managedBy === name)(data)
            if (!isNil(managed)) {
              setValue('area', managed[area], {
                shouldDirty: true
              })
              setArea(managed[area])
              setValue('office', managed[office], {
                shouldDirty: true
              })
              setDisabled(true)
            }
          } else {
            setDisabled(false)
          }
        })
        .catch(() => undefined)
    }, [
      isLoading,
      total,
      dataProvider,
      setAllArea,
      setAllOffice,
      allArea,
      allOffice,
      values
    ])
    if (
      isLoading ||
      (!isNil(total) && total > 0 && (isEmpty(allArea) || isEmpty(allOffice)))
    ) {
      return <Loading />
    }
    const { useArea, useOffice } = configAccounts
    return (
      // <FormDataConsumer<{
      //   name: string
      //   email: string
      //   group: string[]
      //   managedBy: string
      // }>>
      //   {({ formData }) => {
      //     return (
      <>
        <TextInput source="name" fullWidth validate={required()} />
        <TextInput
          source="email"
          type="email"
          fullWidth
          validate={required()}
        />
        <GroupInput source="group" />
        {!isNil(useArea) && (useArea as boolean) && (
          <SelectInput
            source="area"
            label="resources.accounts.fields.area"
            readOnly={disabled}
            choices={
              disabled
                ? [{ id: selectArea, name: selectArea }]
                : map((item: string) => ({
                    id: item,
                    name: item
                  }))(allArea)
            }
            onChange={(
              event: React.ChangeEvent<HTMLInputElement> | RaRecord<Identifier>
            ): void => {
              setArea(event.target.value)
              if (isEmpty(event.target.value)) {
                setValue('office', '', {
                  shouldDirty: true
                })
              }
            }}
          />
        )}
        {!isNil(useOffice) && (useOffice as boolean) && (
          <SelectInput
            source="office"
            label="resources.accounts.fields.office"
            readOnly={isNil(selectArea) || disabled}
            choices={
              isNil(selectArea)
                ? []
                : map((item: string) => ({
                    id: item,
                    name: item
                  }))(allOffice[selectArea as keyof typeof allOffice])
            }
          />
        )}
      </>
      //     )
      //   }}
      // </FormDataConsumer>
    )
  }
  const handleClose = (): void => {
    setMutate(false)
  }
  const AccountsMutateToolbar: React.FC = () => {
    return (
      <Toolbar>
        <Button variant="outlined" onClick={handleClose} sx={{ mr: '1em' }}>
          {translate('resources.accounts.dialogs.mutate.buttons.cancel')}
        </Button>
        <SaveButton label="resources.accounts.dialogs.mutate.buttons.done" />
      </Toolbar>
    )
  }
  const dialog = React.useMemo(() => {
    return (
      <Dialog onClose={handleClose} open={mutate} maxWidth="md" fullWidth>
        <DialogTitle>
          {!isNil(mode)
            ? translate(`resources.accounts.dialogs.${mode}.title`)
            : ''}
        </DialogTitle>
        <DialogContent>
          {mode === 'create' && (
            <CreateBase
              resource="accounts"
              redirect={false}
              mutationOptions={{
                onSuccess: () => {
                  handleClose()
                  refresh()
                }
              }}>
              <SimpleForm toolbar={<AccountsMutateToolbar />}>
                <AccountsMutateFormContent />
              </SimpleForm>
            </CreateBase>
          )}
          {mode === 'edit' && !isNil(record) && (
            <EditBase
              id={record}
              resource="accounts"
              redirect={false}
              mutationMode="pessimistic"
              mutationOptions={{
                onSuccess: () => {
                  handleClose()
                  refresh()
                }
              }}>
              <SimpleForm toolbar={<AccountsMutateToolbar />}>
                <AccountsMutateFormContent />
              </SimpleForm>
            </EditBase>
          )}
        </DialogContent>
      </Dialog>
    )
  }, [mode, mutate])
  const AccountsListContent: React.FC = () => {
    const { isLoading } = useListContext()
    if (isLoading) return <Loading />
    const handleRowClick: RowClickFunction = (
      id: Identifier,
      _resource: string,
      _record: RaRecord
    ): any => {
      setMode('edit')
      setMutate(true)
      setRecord(id as string)
      return false
    }
    const { group } = configAccounts
    return (
      <Datagrid rowClick={handleRowClick}>
        <TextField source="name" sx={{ display: 'block', width: 150 }} />
        <TextField source="email" sx={{ display: 'block', width: 300 }} />
        <FunctionField
          label="resources.accounts.fields.group"
          render={(record: { group: string[] }) =>
            join(',')(map((item: string) => group[item])(record.group))
          }
          sx={{ display: 'block', width: 200 }}
        />
        <TextField source="area" sx={{ display: 'block', width: 100 }} />
        <TextField source="office" sx={{ display: 'block', width: 100 }} />
      </Datagrid>
    )
  }
  const accountListFilters = [
    <TextInput source="name" alwaysOn resettable />,
    <TextInput source="email" alwaysOn resettable />,
    <SelectInput
      source="group"
      label="resources.accounts.fields.group"
      choices={map((key: string) => ({
        id: key,
        name: configAccounts.group[key]
      }))(keys(configAccounts.group))}
      alwaysOn
      resettable
    />
  ]
  return (
    <>
      <ListBase resource="accounts" disableSyncWithLocation>
        <ListToolbar
          actions={<AccountsListActions />}
          filters={accountListFilters}
        />
        <AccountsListContent />
        <Pagination />
      </ListBase>
      {mutate && !isNil(mode) && dialog}
      <SolarAccountsUploadDialog
        open={upload}
        setOpen={setUpload}
        partner={partner}
      />
      <SolarAccountsDownloadDialog
        open={download}
        setOpen={setDownload}
        partner={partner}
        config={config}
      />
    </>
  )
}
